import React, { useState, useEffect } from "react";
import "./Pagamentos.css";
const API_URL = process.env.REACT_APP_API_URL;

const Pagamentos = () => {
  const [pagamentos, setPagamentos] = useState([]);
  const [novoPagamento, setNovoPagamento] = useState({
    title: "",
    unitPrice: "",
    dateOfExpiration: "",
    description: ""
  });
  const [msg, setMsg] = useState("");
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [modalDetalhesAberta, setModalDetalhesAberta] = useState(false);
  const [modalCriarAberta, setModalCriarAberta] = useState(false);

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 5;

  const token = localStorage.getItem("token");

  useEffect(() => {
    listarPagamentos();
  }, [page]);

  const listarPagamentos = async () => {
    try {
      const res = await fetch(`${API_URL}/payments?page=${page}&size=${pageSize}&sortBy=id&direction=desc`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
      });
      const data = await res.json();
      setPagamentos(data.content || []);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Erro ao listar pagamentos:", error);
    }
  };

  const buscarPagamentoPorId = async (id) => {
    try {
      const res = await fetch(`${API_URL}/payments/${id}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
      });
      const data = await res.json();
      setPagamentoSelecionado(data);
      setModalDetalhesAberta(true);
    } catch (error) {
      console.error("Erro ao buscar pagamento:", error);
    }
  };

  const formatarDataParaISO = (data) => {
    const [dia, mes, ano] = data.split("/");
    return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
  };

  const criarPagamento = async () => {
    if (!novoPagamento.title || !novoPagamento.unitPrice || !novoPagamento.dateOfExpiration) {
      setMsg("Preencha todos os campos!");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/payments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          title: novoPagamento.title,
          unitPrice: parseFloat(novoPagamento.unitPrice),
          dateOfExpiration: formatarDataParaISO(novoPagamento.dateOfExpiration),
          description: novoPagamento.description
        }),
      });

      if (response.ok) {
        setMsg("Pagamento criado com sucesso!");
        setNovoPagamento({ title: "", unitPrice: "", dateOfExpiration: "", description: "" });
        setModalCriarAberta(false);
        listarPagamentos();
      } else {
        setMsg("Erro ao criar pagamento.");
      }
    } catch (error) {
      console.error("Erro ao criar pagamento:", error);
      setMsg("Erro ao criar pagamento.");
    }
  };

  const deletarPagamento = async (id) => {
    try {
      await fetch(`${API_URL}/payments/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
      });
      listarPagamentos();
    } catch (error) {
      console.error("Erro ao deletar pagamento:", error);
    }
  };

  const aplicarMascaraData = (valor) => {
    valor = valor.replace(/\D/g, "");
    if (valor.length >= 3 && valor.length <= 4)
      return valor.replace(/(\d{2})(\d{1,2})/, "$1/$2");
    if (valor.length >= 5)
      return valor.replace(/(\d{2})(\d{2})(\d{1,4})/, "$1/$2/$3");
    return valor;
  };

  const handleDataChange = (e) => {
    const valor = e.target.value;
    const valorFormatado = aplicarMascaraData(valor);
    setNovoPagamento({ ...novoPagamento, dateOfExpiration: valorFormatado });
  };

  const copiarLink = () => {
    if (pagamentoSelecionado?.initPoint) {
      navigator.clipboard.writeText(pagamentoSelecionado.initPoint)
        .then(() => alert("Link copiado!"))
        .catch(() => alert("Erro ao copiar link."));
    }
  };

  const fecharModal = () => {
    setModalDetalhesAberta(false);
    setPagamentoSelecionado(null);
  };

  const avancarPagina = () => {
    if (page < totalPages - 1) {
      setPage(page + 1);
    }
  };

  const voltarPagina = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  return (
    <div className="pagamentos-container">
      <h2>Pagamentos</h2>

      <button className="btn-novo" onClick={() => setModalCriarAberta(true)}>+ Novo Pagamento</button>

      {msg && (
        <p className={`pagamento-msg ${msg.includes("Erro") ? "erro" : ""}`}>
          {msg}
        </p>
      )}

      <div className="lista-pagamentos">
        {pagamentos.map((pagamento) => (
          <div
            key={pagamento.id}
            className="pagamento-item"
            onClick={() => buscarPagamentoPorId(pagamento.id)}
            style={{ cursor: "pointer" }}
          >
            <h4>{pagamento.title}</h4>
            <p>Valor: R$ {pagamento.unitPrice.toFixed(2)}</p>
            <p>Expira em: {new Date(pagamento.dateOfExpiration).toLocaleDateString("pt-BR")}</p>
            <p>
              Status: {
                pagamento.status === "paid" ? "✅ Paid" :
                  pagamento.status === "pending" ? "🟦 Pending" :
                    pagamento.status === "expired" || pagamento.status === "canceled" ? "❌ " + pagamento.status.charAt(0).toUpperCase() + pagamento.status.slice(1) :
                      pagamento.status
              }
            </p>

          </div>
        ))}
      </div>



      {page > 0 &&(
      <div className="paginacao-container">
        <button className="paginacao-botao" onClick={voltarPagina} disabled={page === 0}>Anterior</button>
        {page + 1}
        <button className="paginacao-botao" onClick={avancarPagina} disabled={page === totalPages - 1}>Próxima</button>
      </div>
      )}





      {/* Modal Detalhes */}
      {modalDetalhesAberta && pagamentoSelecionado && (
        <div className="modal">
          <div className="modal-conteudo">
            <h3>Detalhes do Pagamento</h3>
            <div style={{ textAlign: "left" }}>
              <p><strong>Título:</strong> {pagamentoSelecionado.title}</p>
              <p><strong>Descrição:</strong> {pagamentoSelecionado.description}</p>
              <p><strong>Valor:</strong> R$ {pagamentoSelecionado.unitPrice.toFixed(2)}</p>
              <p><strong>Status:</strong> {pagamentoSelecionado.status}</p>
              <p><strong>Expira em:</strong> {new Date(pagamentoSelecionado.dateOfExpiration).toLocaleString('pt-BR')}</p>
              <p><strong>Link de Pagamento:</strong></p>
              <a href={pagamentoSelecionado.initPoint} target="_blank" rel="noopener noreferrer">
                {pagamentoSelecionado.initPoint}
              </a>
            </div>

            <div className="buttons">
              <button className="copy-btn" onClick={copiarLink}>Copiar Link</button>
              <button
                className="whatsapp-btn"
                onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(pagamentoSelecionado.initPoint)}`, "_blank")}
              >
                Compartilhar no WhatsApp
              </button>
              <button className="close-btn" onClick={fecharModal}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Criar Pagamento */}
      {modalCriarAberta && (
        <div className="modal">
          <div className="modal-conteudo">
            <h3>Criar Pagamento</h3>
            <input
              type="text"
              name="title"
              placeholder="Título"
              value={novoPagamento.title}
              onChange={(e) => setNovoPagamento({ ...novoPagamento, title: e.target.value })}
            />
            <input
              type="number"
              name="unitPrice"
              placeholder="Preço"
              value={novoPagamento.unitPrice}
              onChange={(e) => setNovoPagamento({ ...novoPagamento, unitPrice: e.target.value })}
            />
            <input
              type="text"
              name="dateOfExpiration"
              placeholder="dd/MM/yyyy"
              maxLength="10"
              value={novoPagamento.dateOfExpiration}
              onChange={handleDataChange}
            />
            <input
              type="text"
              name="description"
              placeholder="Descrição"
              value={novoPagamento.description}
              onChange={(e) => setNovoPagamento({ ...novoPagamento, description: e.target.value })}
            />
            <button onClick={criarPagamento}>Salvar</button>
            <button className="close-btn" onClick={() => setModalCriarAberta(false)}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pagamentos;
